import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { DollarSign, TrendingUp, AlertTriangle, Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { KPICard, DataTable, formatCurrency } from '../reportShared';

export default function HighCostTab({ highCostClaims }) {
  const totalValue = highCostClaims.reduce((s, c) => s + c.amount, 0);

  return (
    <div className="space-y-6" data-testid="reports-high-cost-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPICard title="High-Cost Claims" value={highCostClaims.length} icon={DollarSign} color="red" />
        <KPICard title="Total Value" value={formatCurrency(totalValue)} icon={TrendingUp} color="amber" />
        <KPICard
          title="Highest Claim"
          value={formatCurrency(highCostClaims[0]?.amount)}
          subtitle={highCostClaims[0]?.patient_name}
          icon={AlertTriangle}
          color="red"
        />
        <KPICard
          title="Avg High Claim"
          value={formatCurrency(highCostClaims.length > 0 ? totalValue / highCostClaims.length : 0)}
          icon={Calendar}
          color="purple"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">High-Cost Claims Distribution</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={highCostClaims.slice(0, 10)}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="claim_id" tick={{ fontSize: 10, angle: -45, textAnchor: 'end' }} height={80} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Bar dataKey="amount" fill="#ef4444" name="Amount" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">High-Cost Claims Details (Top 20)</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            columns={[
              { key: 'claim_id', header: 'Claim ID' },
              { key: 'patient_name', header: 'Patient' },
              { key: 'hospital_name', header: 'Hospital' },
              { key: 'amount', header: 'Amount', align: 'right', render: (val) => formatCurrency(val) },
              {
                key: 'status',
                header: 'Status',
                render: (val) => (
                  <Badge variant={val?.toUpperCase() === 'PAID' ? 'success' : val?.toUpperCase() === 'REJECTED' ? 'destructive' : 'warning'}>
                    {val}
                  </Badge>
                )
              },
              { key: 'date', header: 'Date' }
            ]}
            data={highCostClaims}
          />
        </CardContent>
      </Card>
    </div>
  );
}
